module.exports = __webpack_public_path__ + "img/emoji-happiest-off.e22160b7.svg";